import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import FlexBox from 'flexbox-react';
import { Input } from 'react-toolbox';
import BreakLine from 'components/BreakLine';
import StyledSelect from 'components/StyledSelect';
import styles from 'styles/form';
import { generateStringsSource, error } from '../../../../../../utils';
import {
  JOB_TYPES,
  CARPET_TYPES,
  CARPET_SIZES,
  VINYL_SIZE_CHOICES,
  VINYL_TYPES,
  WOOD_FLOORING_TYPES,
  WOOD_INSTALL_TYPES,
  TILE_STONE_LOCATIONS,
  WALL_JOB_TYPES,
  TILE_OR_STONE_STYLES,
  TILE_OR_STONE_SIZES,
  TILE_OR_STONE_PATTERN_TYPES,
  TILE_JOB_TYPES,
  TILE_STYLES,
  TILE_SIZES,
  TILE_PATTERNS,
} from 'config/constants';
import PhaseType from 'types/phase';

const largeInput = cx(styles.inputs, styles.largeInput);

class PhaseSurfaceInfoForm extends Component {
  constructor(props) {
    super(props);
    this.handleRooms = this.props.onChange.bind(this, 'rooms');
    this.handleCarpetType = this.props.onChange.bind(this, 'carpet_type');
    this.handleCarpetSize = this.props.onChange.bind(this, 'carpet_size');
    this.handlePatternSize = this.props.onChange.bind(this, 'pattern_size');
    this.handleComments = this.props.onChange.bind(this, 'comments');
    this.handleJobType = this.props.onChange.bind(this, 'job_type');
    this.handleVinylSizeChoices = this.props.onChange.bind(this, 'vinyl_size_choices');
    this.handleVinylInstallType = this.props.onChange.bind(this, 'vinyl_install_type');
    this.handleVinylPatternSize = this.props.onChange.bind(this, 'vinyl_pattern_size');
    this.handleNewTileStyle = this.props.onChange.bind(this, 'new_tile_style');
    this.handleTileSize = this.props.onChange.bind(this, 'tile_size');
    this.handleTilePattern = this.props.onChange.bind(this, 'tile_pattern');
    this.handleWoodFlooringType = this.props.onChange.bind(this, 'wood_flooring_type');
    this.handleWoodInstallType = this.props.onChange.bind(this, 'wood_install_type');
    this.handleTileStoneLocation = this.props.onChange.bind(this, 'tile_stone_location');
    this.handleBacksplashJobType = this.props.onChange.bind(this, 'backsplash_job_type');
    this.handleStoneStyle = this.props.onChange.bind(this, 'stone_style');
    this.handleStoneSize = this.props.onChange.bind(this, 'stone_size');
    this.handleStonePatternType = this.props.onChange.bind(this, 'stone_pattern_type');
    this.handleSquareFeet = this.props.onPhaseChange.bind(this, 'sqft');
    this.handleNetSquareFeet = this.props.onPhaseChange.bind(this, 'net_square_footage');
  }

  renderCarpetForm() {
    const surfaceInfo = this.props.phase.surface_information;
    return (
      <FlexBox flexWrap="wrap">
        <StyledSelect
          className={largeInput}
          label="Job Type"
          onChange={this.handleJobType}
          options={generateStringsSource(JOB_TYPES)}
          value={surfaceInfo.job_type || ''}
          placeholder={'Select Job Type'}
        />
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
        <StyledSelect
          className={largeInput}
          label="Carpet Type"
          onChange={this.handleCarpetType}
          options={generateStringsSource(CARPET_TYPES)}
          value={surfaceInfo.carpet_type || ''}
          placeholder={'Select Carpet Type'}
        />
        <StyledSelect
          className={largeInput}
          label="Carpet Size"
          onChange={this.handleCarpetSize}
          options={generateStringsSource(CARPET_SIZES)}
          value={surfaceInfo.carpet_size || ''}
          placeholder={'Select Carpet Size'}
        />
        <BreakLine />
        <Input
          label="Pattern Size"
          className={largeInput}
          value={surfaceInfo.pattern_size || ''}
          onChange={this.handlePatternSize}
        />
      </FlexBox>
    );
  }

  renderVinylForm() {
    const surfaceInfo = this.props.phase.surface_information;

    return (
      <FlexBox flexWrap="wrap">
        <StyledSelect
          className={largeInput}
          label="Job Type"
          onChange={this.handleJobType}
          options={generateStringsSource(JOB_TYPES)}
          value={surfaceInfo.job_type || ''}
          placeholder={'Select Job Type'}
        />
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
        <StyledSelect
          className={largeInput}
          label="Vinyl Size Choices"
          onChange={this.handleVinylSizeChoices}
          options={generateStringsSource(VINYL_SIZE_CHOICES)}
          value={surfaceInfo.vinyl_size_choices || ''}
          placeholder={'Select Vinyl Install Type'}
        />
        <StyledSelect
          className={largeInput}
          label="Vinyl Install Type"
          onChange={this.handleVinylInstallType}
          options={generateStringsSource(VINYL_TYPES)}
          value={surfaceInfo.vinyl_install_type || ''}
          placeholder={'Select Vinyl Install Type'}
        />
        <BreakLine />
        <Input
          label="Vinyl Pattern Size"
          className={largeInput}
          value={surfaceInfo.vinyl_pattern_size || ''}
          onChange={this.handleVinylPatternSize}
        />
      </FlexBox>
    );
  }

  renderLaminateForm() {
    const surfaceInfo = this.props.phase.surface_information;

    return (
      <FlexBox flexWrap="wrap">
        <StyledSelect
          className={largeInput}
          label="Job Type"
          onChange={this.handleJobType}
          options={generateStringsSource(JOB_TYPES)}
          value={surfaceInfo.job_type || ''}
          placeholder={'Select Job Type'}
        />
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
      </FlexBox>
    );
  }

  renderTileForm() {
    const surfaceInfo = this.props.phase.surface_information;

    return (
      <FlexBox flexWrap="wrap">
        <StyledSelect
          className={largeInput}
          label="Job Type"
          onChange={this.handleJobType}
          options={generateStringsSource(TILE_JOB_TYPES)}
          value={surfaceInfo.job_type || ''}
          placeholder={'Select Job Type'}
        />
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
        <StyledSelect
          className={largeInput}
          label="New Tile Style"
          onChange={this.handleNewTileStyle}
          options={generateStringsSource(TILE_STYLES)}
          value={surfaceInfo.new_tile_style || ''}
          placeholder={'Select New Tile Style'}
        />
        <StyledSelect
          className={largeInput}
          label="Tile Size"
          onChange={this.handleTileSize}
          options={generateStringsSource(TILE_SIZES)}
          value={surfaceInfo.tile_size || ''}
          placeholder={'Select Tile Size'}
        />
        <StyledSelect
          className={largeInput}
          label="Tile Pattern"
          onChange={this.handleTilePattern}
          options={generateStringsSource(TILE_PATTERNS)}
          value={surfaceInfo.tile_pattern || ''}
          placeholder={'Select Tile Pattern'}
        />
      </FlexBox>
    );
  }

  renderHardwoodForm() {
    const surfaceInfo = this.props.phase.surface_information;

    return (
      <FlexBox flexWrap="wrap">
        <StyledSelect
          className={largeInput}
          label="Job Type"
          onChange={this.handleJobType}
          options={generateStringsSource(JOB_TYPES)}
          value={surfaceInfo.job_type || ''}
          placeholder={'Select Job Type'}
        />
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
        <StyledSelect
          className={largeInput}
          label="Wood Flooring Type"
          onChange={this.handleWoodFlooringType}
          options={generateStringsSource(WOOD_FLOORING_TYPES)}
          value={surfaceInfo.wood_flooring_type || ''}
          placeholder={'Select Wood Flooring Type'}
        />
        <StyledSelect
          className={largeInput}
          label="Wood Install Type"
          onChange={this.handleWoodInstallType}
          options={generateStringsSource(WOOD_INSTALL_TYPES)}
          value={surfaceInfo.wood_install_type || ''}
          placeholder={'Select Wood Install Type'}
        />
      </FlexBox>
    );
  }

  renderBacksplashForm() {
    const surfaceInfo = this.props.phase.surface_information;

    return (
      <FlexBox flexWrap="wrap">
        <Input
          label="Rooms"
          className={largeInput}
          value={surfaceInfo.rooms || ''}
          onChange={this.handleRooms}
        />
        <StyledSelect
          className={largeInput}
          label="Tile/Stone Location"
          onChange={this.handleTileStoneLocation}
          options={generateStringsSource(TILE_STONE_LOCATIONS)}
          value={surfaceInfo.tile_stone_location || ''}
          placeholder={'Select Tile/Stone Location'}
        />
        <StyledSelect
          className={largeInput}
          label="Backsplash/Wall Job Type"
          onChange={this.handleBacksplashJobType}
          options={generateStringsSource(WALL_JOB_TYPES)}
          value={surfaceInfo.backsplash_job_type || ''}
          placeholder={'Select Backsplash/Wall Job Type'}
        />
        <StyledSelect
          className={largeInput}
          label="Backsplash tile or stone style"
          onChange={this.handleStoneStyle}
          options={generateStringsSource(TILE_OR_STONE_STYLES)}
          value={surfaceInfo.stone_style || ''}
          placeholder={'Select Backsplash tile or stone style'}
        />
        <StyledSelect
          className={largeInput}
          label="Backsplash tile or stone size"
          onChange={this.handleStoneSize}
          options={generateStringsSource(TILE_OR_STONE_SIZES)}
          value={surfaceInfo.stone_size || ''}
          placeholder={'Select Backsplash tile or stone size'}
        />
        <StyledSelect
          className={largeInput}
          label="Backsplash Tile or Stone Pattern Type"
          onChange={this.handleStonePatternType}
          options={generateStringsSource(TILE_OR_STONE_PATTERN_TYPES)}
          value={surfaceInfo.stone_pattern_type || ''}
          placeholder={'Select Tile or Stone Pattern Type'}
        />
      </FlexBox>
    );
  }

  render() {
    const { phase, errors } = this.props;
    const surfaceInfo = phase.surface_information;
    const surfaceType = phase.surface_type || {};
    const surfaceName = surfaceType.name || '';

    return (
      <div>
        <FlexBox flexWrap="wrap" className={styles.divider}>
          {(() => {
            switch (surfaceName) {
              case 'Carpet': return this.renderCarpetForm();
              case 'Vinyl': return this.renderVinylForm();
              case 'Laminate': return this.renderLaminateForm();
              case 'Tile': return this.renderTileForm();
              case 'Hardwood': return this.renderHardwoodForm();
              case 'Backsplash': return this.renderBacksplashForm();
              default: return null;
            }
          })()}
          <BreakLine />
          <Input
            label="Project Square Feet"
            className={largeInput}
            value={phase.sqft || ''}
            onChange={this.handleSquareFeet}
            error={error('sqft', errors)}
          />
          <Input
            label="Net Square Feet"
            className={largeInput}
            value={phase.net_square_footage || ''}
            onChange={this.handleNetSquareFeet}
            error={error('net_square_footage', errors)}
          />

          <Input
            label="Comments"
            className={largeInput}
            value={surfaceInfo.comments || ''}
            onChange={this.handleComments}
          />
        </FlexBox>
      </div>
    );
  }
}

PhaseSurfaceInfoForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  onPhaseChange: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.object,
};

export default PhaseSurfaceInfoForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseEdit/components/phaseSurfaceInfoForm.jsx